import OSS from 'ali-oss'
export const fetchUploadFileToOss = (params: FormData) => {
  const client = new OSS({
    region: 'oss-cn-shanghai',
    accessKeyId: 'LTAIcsnlOuTz1P1j',
    accessKeySecret: 'qftvfRZ0OLyPbI6WDpqj3OdWZBO5J4',
    bucket: 'jufair'
  })

  return client.put(params.get('key') as string, params.get('file'))
}
